export default {"src":"/_next/static/media/facebook.58efafb9.svg","height":512,"width":512};